import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
        
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProducto ?
                                    { key: this.props.filter.idProducto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por producto" />}
                            onChange={(option) => this.props.onChange("idProducto", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.productos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;